import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AI_BOT_CONFIG, BASE_DOMAIN_URI, BASE_URI, config } from 'app/app.config';

@Injectable({
  providedIn: 'root'
})
export class SummarizeService {

    baseUrl = BASE_URI.URL;

    llm_model2_url = `${AI_BOT_CONFIG.training.model2Url}`;

  constructor(private http:HttpClient) { }

  getSummarize(payLoad:any){
    // let payload = {
    //   "text":extractText,
    //   "task":"summarization"
    //   };
    // return this.http.post("https://document.canstringai.com:8443/ca-llm/multiple_task",payload);

    return this.http.post(this.llm_model2_url + "/generalgpt/query",payLoad);
  }

  uploadSummaryPdf(payload:any){
    return this.http.post(BASE_DOMAIN_URI + "/pdf/upload-pdf",payload);
  }

  createHistory(payLoad:any){
    return this.http.post(`${this.baseUrl}/createHistory`, payLoad);
  }

  getChatBotHistory(){
    let user_id = window.localStorage.getItem('user_id');
    return this.http.get(`${this.baseUrl}/getChatBotHistory?user_id=${user_id}`);
  }


}
